import { render, staticRenderFns } from "./SubmissionEdit.vue?vue&type=template&id=7e07456a&scoped=true&"
import script from "./SubmissionEdit.vue?vue&type=script&lang=js&"
export * from "./SubmissionEdit.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionEdit.vue?vue&type=style&index=0&id=7e07456a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e07456a",
  null
  
)

export default component.exports